// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l6l1","type":"styles_type__1feaP","choices":"styles_choices__CVYfn"};